import React from 'react';


interface PortfolioHealthScoreProps {
  healthScore: number;
}

const getHealthLabel = (score: number) => {
  if (score >= 70) return 'Équilibré';
  if (score >= 40) return 'Concentration modérée';
  if (score > 0) return 'Concentration élevée';
  return 'Aucune position';
};

const getHealthInterpretation = (score: number) => {
  if (score >= 70) return 'Votre portefeuille est bien diversifié et présente un risque modéré.';
  if (score >= 40) return 'Votre portefeuille présente une concentration modérée. Une diversification supplémentaire est recommandée.';
  if (score > 0) return 'Votre portefeuille est très concentré sur un actif. Diversifiez pour réduire le risque.';
  return 'Aucune position valorisée dans le portefeuille.';
};

const PortfolioHealthScore: React.FC<PortfolioHealthScoreProps> = ({ healthScore }) => {
  const label = getHealthLabel(healthScore);
  const interpretation = getHealthInterpretation(healthScore);
  return (
    <section style={{
      background: 'linear-gradient(90deg, #1976d2 0%, #43a047 100%)',
      borderRadius: 24,
      padding: '48px 40px',
      minHeight: 180,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      boxShadow: '0 4px 24px #1976d233',
    }}>
      <div style={{ fontSize: 64, fontWeight: 900 }}>{Math.round(healthScore)}</div>
      <div style={{ fontSize: 22, fontWeight: 700, marginTop: 8 }}>Score de Santé du Portefeuille</div>
      <div style={{ fontSize: 18, marginTop: 4 }}>{label}</div>
      <div style={{ fontSize: 15, marginTop: 12, opacity: 0.8 }}>{interpretation}</div>
    </section>
  );
};

export default PortfolioHealthScore;
